import { createContext } from "react"

export const AssessmentFormulaBuilderContext = createContext(null)
